export default {"src":"/_next/static/media/ic_edit_button.9695651b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};